export const reemaColors = {
  black: '#191c1d',
  darkGray: '#40484b',
  primaryContainer: '#b5ebff',
  successBackground: '#d2efd4',
  removedBackground: '#dce4e8',
  lightBackground: '#fbfcfe',
  success: '#39a73e',
  successText: '#133415',
  borderCard: '#eaeded',
  action: '#167e99',
  actionActive: '#37b3d6',
  iconDefault: 'rgba(10, 33, 39, 0.7)',
  iconContrast: '#001F28',
  iconLight: '#dce4e8',
  textDefault: '#0a2127',
  textLight: '#7b807f',
  reminder: '#e35fa3',
  incoming: '#36ad70',
  'incoming-missed': '#36ad70',
  'outline-light': '#70787c',
  outgoing: '#21bce4',
  'outgoing-missed': '#21bce4',
  team: '#f2963f',
  resourcing: '#8d4299',
  note: '#21bce4',
  failure: '#ba1a1a',
  quietBackground: '#f5f5f5',
  pacificPleasure: '#167E99',
  alertLowDark: '#c26b00',
  alertLow: '#ffe4bd',
  warning: '#ba1a1a',
  warningLight: '#ffdad6',
  warningText: '#410002',
  amazingGray: '#e5e5e5',
  reemaBlue: '#21bce4',
  base: '#EFF1F2',
  lightGray: '#e0e0e0',
};

/**
 * Surface variant is also used for infoContainers.
 * onSurface is the color for infoText.
 */
export const themeColors = {
  error: '#ba1a1a',
  errorContainer: '#ffdad6',
  containerLight: '#ffffff',
  inverseOnSurface: '#eff1f2',
  onErrorContainer: '#410002',
  onSuccessContainer: '#133415',
  onSurface: '#191c1d',
  onSurfaceVariant: '#40484b',
  onSurfaceSecondary: '#4c626a',
  onWarningContainer: '#3d2100',
  primary: '#167e99',
  success: '#39a73e',
  successContainer: '#d2efd4',
  surfaceVariant: '#dce4e8',
  surfaceSecondary: '#cfe6f0',
  warning: '#3d2100',
  warningContainer: '#ffe4bd',
};

export type BUTTON_COLORS =
  | 'default'
  | 'primary'
  | 'secondary'
  | 'success'
  | 'error'
  | 'info'
  | 'warning';

// Re-export alert color tokens (legacy - prefer using tokens/ for new code)
export * from './colors/alert-colors';

// Re-export comprehensive design token system
export * from './tokens';
